import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

// namespace SlotGames {

    export class StickyChilli_2Screen extends SlotGameType1_2Screen {


        
        protected override helpFactory: IHelpFactory = new StickyChilliHelpFactory();
        //protected panelFactory:IPanelFactory = new StickyChilliPanelFactory();
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "purple",
            }
        //LED COLOR
		protected override ColorLed:string="255,64,0\n";

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "StickyChilli");

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // public PrepareFont(resourceManager: ResourceManager) {
        //     resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
        // }

    }

    //Help Colorized
    class StickyChilliHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new StickyChilliHelp(params);
        }
    }

    class StickyChilliHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(64, 21, 21),rgb(140, 4, 4), rgb(191, 6, 6),rgb(140, 4, 4),rgb(64, 21, 21)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

    	//Panel Colorized
		class StickyChilliPanelFactory implements IPanelFactory
        {
            public CreateNewPanel(params: PanelParams):Panel
            {
                return new StickyChilliPanel(params);
            }
        }
    
        class StickyChilliPanel extends Panel
        {
            protected override ButtonBackground():ButtonColors
            {
                let color:ButtonColors = {
                    backgroundButtonColor: "linear-gradient(rgb(64, 21, 21),rgb(140, 4, 4), rgb(191, 6, 6),rgb(140, 4, 4),rgb(64, 21, 21)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                    linearColor:"linear-gradient(to left , transparent, yellowgreen,transparent ) 0 10 100%",
                };
    
                return color;
            }
        }

// }
